export default __webpack_public_path__ + "static/media/eSignIcon.1264393f.svg";